module.exports = __webpack_public_path__ + "img/Jump Casting110.4b91ec16.jpg";